module.exports = __webpack_public_path__ + "img/AnalysisScreenShot5.e4a136ec.png";